import React from 'react';
import {concatenate} from "services/string";
import {Colour} from "../Card/Card";

type Props = {
    colour: Colour
    ping?: boolean
}

const dotColours: Record<Colour, string> = {
    'brand': 'bg-brand',
    'blue': 'bg-blue-500',
    'green': 'bg-green-500',
    'yellow': 'bg-yellow-500',
    'red': 'bg-red-500',
    'gray': 'bg-gray-500',
}

const pingColours: Record<Colour, string> = {
    'brand': 'bg-brand/80',
    'blue': 'bg-blue-400',
    'green': 'bg-green-400',
    'yellow': 'bg-yellow-400',
    'red': 'bg-red-400',
    'gray': 'bg-gray-400',
}

function Dot({colour, ping}: Props) {
    return (
        <span className="flex h-3 w-3 ">
            {ping &&
                <span className={concatenate(
                    pingColours[colour],
                    'animate-ping absolute inline-flex h-full w-full rounded-full opacity-75'
                )}/>
            }

            <span className={concatenate(
                dotColours[colour],
                'relative inline-flex rounded-full h-3 w-3'
            )}/>
        </span>
    );
}

export default Dot;